<template>
  <v-row class="ma-0" justify="center">
    <v-dialog v-model="active" :persistent="fix" max-width="400">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon v-if="!fix" size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:60px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-row class="ma-0 mb-5" justify="center">          
          <div style="width:60%">
            <v-img v-if="type == 1" :src="images.successInfo_1"></v-img>
            <v-img v-if="type == 2" :src="images.successInfo_2"></v-img>
          </div>
        </v-row>
        <v-row class="ma-0" justify="center">          
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#7AC7FC"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'SuccessInfo',
    props:['onSave'],
    data () {
      return {
        images:{
          successInfo_1: require('@/assets/image/successInfo-1.png'),
          successInfo_2: require('@/assets/image/successInfo-2.png'),
        },
        active: false,
        type: 0,
        title: '',
        content: '',
        onSaveEn: false,
        fix: true,
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false){
        this.active = true
        this.type = type
        this.onSaveEn = onSaveEn
        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = '報名成功'
            this.content = '感謝您的報名，將有專人去電服務，學校相關活動會不定期通知，請您留意訊息。'
            break
          case 2:
            this.title = '報名成功'
            this.content = '感謝您的報名，將有專人去電安排面試，學校相關活動會不定期通知，請您留意訊息。'
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave()
        }
        this.close()
      }
    }
  }
</script>